import type { FeatureKey, Role } from '@/lib/api/types';
import { useApp } from './app-context';

// Mirrors the backend role groups (backend/src/core/auth/decorators.ts).
const GROUPS = {
  /** Read every office screen. */
  office: ['OWNER', 'MANAGER', 'ACCOUNTANT'],
  /** Record money and edit records (the owner only reads and approves). */
  write: ['MANAGER', 'ACCOUNTANT'],
  /** Approve discounts, advances and payroll; change settings. */
  approve: ['OWNER', 'MANAGER'],
  /** Write off advances, add managers. */
  owner: ['OWNER'],
  /** See attendance (teachers see only their classes). */
  attendance: ['OWNER', 'MANAGER', 'ACCOUNTANT', 'TEACHER'],
} as const satisfies Record<string, readonly Role[]>;

export type Permission = keyof typeof GROUPS;

export function roleCan(role: Role | null | undefined, permission: Permission): boolean {
  return !!role && (GROUPS[permission] as readonly Role[]).includes(role);
}

export function useCan(): (permission: Permission) => boolean {
  const { role } = useApp();
  return (permission) => roleCan(role, permission);
}

export function useFeature(key: FeatureKey): boolean {
  return useApp().features[key];
}
